<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 md6>
        <h2></h2>
      </v-flex>
      <v-flex xs12 md6 style="text-align: end;">
        <v-btn color="primary"  @click="open_dialog('backlog_report_edit')" v-if="myPermissions.includes(44)" :style="dark_t?'color:black':''">
					<fs1 tag="span">Cambiar link</fs1>
        </v-btn>
      </v-flex>
    </v-layout>
		<br>
		<div style="padding: 60px;text-align: center;">
			<v-btn color="primary" @click="go_to_backlog" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''" :disabled="!link">
				<fs1 tag="span">Acceso a Backlog</fs1>
			</v-btn>
		</div>

		<fs1-dialog id="backlog_report_edit" max_width="400" title="Editar">
			<template v-slot:body>
				<div style="text-align: left;">
					<in-text v-model="selectedItem.link" label="Link"/>
				</div>
			</template>
			<template v-slot:footer="{close}">
				<v-btn color="secondary" @click="close">Cancelar</v-btn>
				<v-btn color="primary" @click="edit">Aceptar</v-btn>
			</template>
		</fs1-dialog>
	</div>
</template>

<script>
export default {
  data() {
    return {
			link:null,
			selectedItem:{
				link:null,
				id:null,
			}
    };
  },
	created(){
		this.requests.get['dashboard/backlog_report']()
			.then(r => {
				this.dev_log({r});
				if (r.link) {
					this.link = r.link;
					this.selectedItem = r;
				}
			})
	},
  methods: {
		edit(){
			this.close_dialog();
			this.requests.patch['dashboard/backlog_report']({link:this.selectedItem.link})
				.then(r => {
					this.dev_log({r});
					if (r.id) {
						this.setSnackbar({message:'Guardado.',class:'success'})
						if (r.link) this.link = r.link;
					}
					else this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
				}).catch(e=> {this.getError(e)})
		},
		go_to_backlog(){
			window.open(this.link, '_blank').focus();
		}
  }, // methods
};
</script>
